import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React, {Component} from 'react';
import App from "../../App";
import {withRouter} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Riders from "./Riders"
import Routes from "./Routes"
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import {Button} from "react-bootstrap";
import { getFormattedDate } from "../../helper/utils";
import { getList } from "../../services/baseServices";

export const KEYS = {
    RIDER: 0,
    ROUTE: 1
}

export const TABLES = {
    ORDER_SUMMARY: 'ORDER_SUMMARY',
    ORDER_LIST: 'ORDER_LIST',
    RETURN_REQUEST: 'RETURN_REQUEST',
    CUSTOME_ORDER: 'CUSTOME_ORDER'
}

class Collections extends Component {
    constructor() {
        super();
        var startDate = localStorage.getItem("reconciliation_st_d") ? moment(localStorage.getItem("reconciliation_st_d")): moment().subtract(29, 'days');
        var today = localStorage.getItem("reconciliation_ed_d") ? moment(localStorage.getItem("reconciliation_ed_d")): moment();

        var seletedTab = localStorage.getItem("reconciliation_tab") ? parseInt(localStorage.getItem("reconciliation_tab")) : KEYS.RIDER;
        this.state = {
            start_date_time: startDate,
            end_date_time: today,
            temp_params: { start_date_time:  getFormattedDate(startDate, "YYYY-MM-DD"), end_date_time: getFormattedDate(today, "YYYY-MM-DD") },
            query_params: { start_date_time:  getFormattedDate(startDate, "YYYY-MM-DD"), end_date_time: getFormattedDate(today, "YYYY-MM-DD") }, 
            selectedTab: seletedTab
        };
    }

    componentWillUnmount() {
        this.setState({})
    }

    componentDidMount() {
        getList("distributors")
          .then((res) => {
            this.setState({ distributors: res });
          })
          .catch((errMsg) => {});
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params);
        return params;
    }

    handleOnFilter = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;

        localStorage.setItem("reconciliation_st_d", this.state.temp_params.start_date_time)
        localStorage.setItem("reconciliation_ed_d", this.state.temp_params.end_date_time)
        this.setState({query_params: tempParam});
    }

    handleOnApply = (e, picker)=>{
        this.setState({start_date_time: getFormattedDate(picker.startDate,''), end_date_time: getFormattedDate(picker.endDate,'')})
        this.setState({temp_params: {...this.state.temp_params, start_date_time: getFormattedDate(picker.startDate, "YYYY-MM-DD"), end_date_time: getFormattedDate(picker.endDate, "YYYY-MM-DD")}})
    }

    onTabChange = (key) => {
        localStorage.setItem("reconciliation_tab", key)
        this.setState({selectedTab: key})
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        this.setState({query_params: tempParam});
    }

    handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData});
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Cash Collection</h2>
                    </div>
                        <div align="center">
                            <form className="form-inline mb-3">
                                <div className="form-group mr-3">
                                    <label htmlFor="status" className="sr-only">
                                        Date Range
                                    </label>
                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: this.state.start_date_time,
                                            endDate: this.state.end_date_time,
                                            maxSpan: {"months": 3},
                                            showDropdowns: true,
                                            locale: {format: "DD/MM/YYYY"},
                                            autoApply: true,
                                        }}
                                        onApply={(e, picker) => this.handleOnApply(e, picker)}
                                    >

                                        <input type="text"
                                            value={this.state.start_date_time && this.state.end_date_time ? `${getFormattedDate(this.state.start_date_time, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time, "DD/MM/YYYY")}` : ''}
                                            style={{textAlign: 'left', minWidth: '150px'}}
                                            placeholder={"Select date range"}
                                            className="form-control form-control-sm"/>
                                    </DateRangePicker>
                                </div>
                                <div className="form-group mr-3">
                                    <label htmlFor="distributor_id" className="sr-only">
                                        Distributor
                                    </label>
                                    <select
                                        id="distributor_id"
                                        name="distributor_id"
                                        value={this.state.temp_params.distributor_id}
                                        className="form-control form-control-sm"
                                        onChange={(e) => {
                                            this.handleOnFieldChange(e);
                                        }}
                                    >
                                    <option value="">--Select Distributor--</option>
                                    {this.state.distributors?.length > 0
                                        ? this.state.distributors.map((item, i) => {
                                            return (
                                            <option key={i} value={item.id}>
                                                {item.name}
                                            </option>
                                            );
                                        })
                                        : ""}
                                    </select>
                                </div>
                                <Button
                                    size="sm"
                                    type={`submit`}
                                    onClick={this.handleOnSearch}
                                    variant="primary"
                                >
                                    Filter
                                </Button>
                            </form>
                        </div>
                    <div className="card-block">
                        <div className="block-body">
                            <Tabs selectedIndex={this.state.selectedTab} onSelect={this.onTabChange}>
                                <TabList>
                                    <Tab eventKey={KEYS.RIDER}>Riders</Tab>
                                    <Tab eventKey={KEYS.ROUTE}>Routes</Tab>
                                </TabList>

                                <TabPanel>
                                    <Riders queryParams={this.state.query_params} />
                                </TabPanel>
                                <TabPanel>
                                    <Routes queryParams={this.state.query_params} />
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>

                <ToastsContainer store={ToastsStore}/>
            </App>
        );
    }
}

export default withRouter(Collections);
